import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from '../styles.module.scss'

export const TextLandEs = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="Bono del 325% hasta €5000 + 400 GIROS GRATIS"
            highlights={[{ word: '325%' }, { word: '€5000' }, { word: '400' }]}
            breakAfterWords={isDesktop ? ['325%', '€5000'] : ['€5000']}
            className={styles.text_land}
        />
    )
}
